<script setup>
// import DatabaseBioPanel from '@/views/apps/database/view/DatabaseBioPanel.vue'
// import DatabaseTabDetails from '@/views/apps/database/view/DatabaseTabDetails.vue'
// import { useDatabaseStatusStore } from '@/composables/useGlobalStore'

const route = useRoute('apps-database-view-id')
const databaseTab = ref(null)
// const databaseStatusStore = useDatabaseStatusStore()
const { data: databaseData } = await useApi(`/apps/databases/${route.params.id}`)
// const database = computed(() => databaseStatusStore.mapStatusToDatabase(databaseData.value))

definePage({
  meta: {
    action: 'read',
    subject: 'databaseconnectiondatas',
  },
})
</script>

<template>
  <VRow v-if="database">
    <VCol cols="12" md="5" lg="4">
      <!-- <DatabaseBioPanel :database-data="database" /> -->
    </VCol>

    <VCol cols="12" md="7" lg="8">
      <VTabs v-model="databaseTab" class="v-tabs-pill">
        <VTab v-for="tab in [
          { title: 'Details', component: DatabaseTabDetails },
        ]" :key="tab.title">
          {{ tab.title }}
        </VTab>
        <VTabItem v-for="tab in [
          { title: 'Details', component: DatabaseTabDetails },
        ]" :key="tab.title">
          <component :is="tab.component" :database-data="database" />
        </VTabItem>
      </VTabs>
    </VCol>
  </VRow>
</template>
